import { render, staticRenderFns } from "./package_title.vue.js?vue&type=template&id=e5fde928!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./package_title.vue?vue&type=template&id=e5fde928"
import script from "./package_title.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./package_title.vue?vue&type=script&lang=js"
export * from "./package_title.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./package_title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports